
import {FC} from "react";

import React from 'react';

import MLAMSCApprovalForm from "../../forms/ppap/mla-msc-approval-form";

interface Interface{
    requestId: any;
    mode?: "Edit" | "Add new";
    onClose?: () => void;
}

interface Interface{
    requestId: any;
    mode?: "Edit" | "Add new";
    onClose?: () => void;
}

const MLAMSCApprovalScreen: FC<Interface> = (props:any) => {

    

    return (
            
                <MLAMSCApprovalForm
                    requestId={props.requestId}
                />
            
    );
}
export default MLAMSCApprovalScreen;
